import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const FadeInView = React.forwardRef(function FadeInView(
  {
    initial,
    whileInView,
    viewport,
    amount = 0.15,
    margin = '0px',
    transition,
    children,
    ...rest
  },
  forwardedRef
) {
  const internalRef = useRef(null);
  const ref = forwardedRef || internalRef;
  const inView = useInView(ref, { once: true, amount, margin });

  return (
    <motion.div
      ref={ref}
      initial={initial}
      animate={inView ? whileInView : initial}
      transition={transition}
      {...rest}
    >
      {children}
    </motion.div>
  );
});

export default FadeInView;
